<script type="module">
import axios from 'axios'
import { format } from 'date-fns/format'
import { addDays } from 'date-fns/addDays'
import { startOfTomorrow } from 'date-fns/startOfTomorrow'
import ModalBus from '@/eventBus'
import DollarPrice from '@/components/DollarPrice.vue'

export default {
  name: 'QuoteFormBookHostHotel',

  components: {
    DollarPrice,
  },

  props: {
    statuses: {
      type: Array,
      required: true,
    },

    countriesList: {
      type: Array,
      required: true,
    },

    hostName: {
      type: String,
      required: true,
    },

    hostHotelsUrl: {
      type: String,
      required: true,
    },

    hasCloseButton: {
      default: false,
      type: Boolean,
    },

    selected: {
      type: Number,
      required: false,
    },

    showEndShuttle: Boolean,
  },

  data() {
    return {
      hostHotelGroups: [],
      form: {
        token: '',
        lastname: window.Laravel.user?.lastname,
        firstname: window.Laravel.user?.firstname,
        email: window.Laravel.user?.email,
        country: window.Laravel.user?.country,
        phone: window.Laravel.user?.phone,
        message: '',
        specific_fields: {
          booking: {
            host_hotel_id: null,
            status: null,
            start_date: format(startOfTomorrow(), 'yyyy-MM-dd'),
            start_shuttle: false,
            start_flight: '',
            start_landing_time: '',
            end_date: format(addDays(startOfTomorrow(), 1), 'yyyy-MM-dd'),
            end_shuttle: false,
            end_flight: '',
            end_landing_time: '',
            adults: null,
            child: null,
            year_child: '',
            rooms: null,
          },
        },
      },

      sending: false,
      errorMessage: '',
      successMessage: '',
      errors: undefined,
      message: '',
    }
  },

  mounted() {
    this.getHostHotelsGroup()
  },

  methods: {
    getHostHotelsGroup() {
      axios
        .get('/api/host-hotels')
        .then(
          (response) =>
            (this.hostHotelGroups = response.data.data.map((group) => {
              group.hotels = group.hotels.map((hotel) => {
                hotel.selected = false
                return hotel
              })

              return group
            })),
        )
        .then(() => {
          this.selectHostHotel(this.selected)
        })
    },

    selectHostHotel(hotelId) {
      this.form.specific_fields.booking.host_hotel_id = hotelId
      this.hostHotelGroups.forEach((group) => {
        group.hotels.forEach((hotel) => {
          hotel.id === hotelId ? (hotel.selected = !hotel.selected) : (hotel.selected = false)
          return hotel
        })
      })
    },

    closeForm() {
      ModalBus.emit('close')
    },

    handleSubmit() {
      this.sending = true
      this.errorMessage = ''
      this.errors = undefined
      this.successMessage = ''

      this.$recaptcha('bookHotel').then((token) => {
        this.form.token = token
        axios
          .post('/submission/book-hotel', this.form)
          .then((response) => {
            this.successMessage = response.data.message
            this.$root.openSuccessBookHostHotel({
              url: this.hostHotelsUrl,
            })
          })
          .catch((error) => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors || {}
            } else if (error.response.status === 500 || error.response.status === 401) {
              this.errorMessage = error.response.data.message
            }
          })
      })
    },
  },
}
</script>

<template>
  <div class="overflow-auto border border-lightgray bg-lightgray lg:rounded-2xl">
    <div class="item-center flex justify-between border-b-2 border-light/25 px-6 py-4">
      <div class="flex items-center">
        <h3 class="font-poppins text-xl font-medium text-secondary">
          {{ $t('host_hotels.quoteForm.title') }}
        </h3>
      </div>
      <button
        :class="!hasCloseButton && 'hidden'"
        class="relative h-10 w-10 rounded-full bg-secondary focus:outline-none"
        @click="closeForm">
        <div
          class="absolute left-1/2 top-1/2 flex h-1/2 w-1/2 -translate-x-1/2 -translate-y-1/2 flex-col items-end justify-between">
          <div class="header-closed absolute bottom-1/2 h-0.5 w-full rotate-45 rounded bg-white"></div>
          <div class="header-closed absolute bottom-1/2 h-0.5 w-full -rotate-45 rounded bg-white"></div>
        </div>
      </button>
    </div>
    <form
      method="POST"
      @submit.prevent="handleSubmit">
      <div class="p-5">
        <div
          v-if="errorMessage"
          class="relative mb-3 mt-3 rounded-lg bg-red-100 px-3 py-3 text-sm text-red-700">
          {{ errorMessage }}
        </div>
        <div
          v-if="successMessage"
          class="relative mb-3 mt-3 rounded-lg bg-emerald-100 px-3 py-3 text-sm text-emerald-700">
          {{ successMessage }}
        </div>

        <div class="flex w-full items-center">
          <user class="h-4 w-4 text-primary"></user>
          <h3 class="ml-4 font-poppins text-xl font-medium">
            {{ $t('host_hotels.quoteForm.sections.first.title') }}
          </h3>
        </div>

        <div class="w-full">
          <div class="grid grid-cols-2 gap-x-4 lg:grid-cols-1 xl:grid-cols-2">
            <label class="form__label">
              <span>{{ $t('commons.quoteForm.customerInfos.form.lastname.label') }}</span>
              <input
                v-model="form.lastname"
                :placeholder="$t('commons.quoteForm.customerInfos.form.lastname.placeholder')"
                class="form__input bg-white"
                name="lastname"
                type="text" />
              <span
                v-if="errors && errors['lastname']"
                class="text-xs text-red-500"
                >{{ errors['lastname'][0] }}</span
              >
            </label>
            <label class="form__label">
              <span>{{ $t('commons.quoteForm.customerInfos.form.firstname.label') }}</span>
              <input
                v-model="form.firstname"
                :placeholder="$t('commons.quoteForm.customerInfos.form.firstname.placeholder')"
                class="form__input bg-white"
                name="lastname"
                type="text" />
              <span
                v-if="errors && errors['firstname']"
                class="text-xs text-red-500"
                >{{ errors['firstname'][0] }}</span
              >
            </label>
          </div>

          <label class="form__label">
            <span>{{ $t('commons.quoteForm.customerInfos.form.email.label') }}</span>
            <input
              v-model="form.email"
              :placeholder="$t('commons.quoteForm.customerInfos.form.email.placeholder')"
              :disabled="$root.user.email"
              :class="$root.user.email ? 'bg-transparent' : 'bg-white'"
              class="form__input"
              name="email"
              type="email" />
            <span
              v-if="errors && errors['email']"
              class="text-xs text-red-500"
              >{{ errors['email'][0] }}</span
            >
          </label>

          <div class="grid grid-cols-2 gap-x-4 lg:grid-cols-1 xl:grid-cols-2">
            <label class="form__label">
              <span>{{ $t('commons.quoteForm.customerInfos.form.country.label') }}</span>
              <select
                v-model="form.country"
                class="form__input bg-white"
                name="country">
                <option
                  disabled
                  :value="null">
                  Sélectionner
                </option>
                <option
                  v-for="country in countriesList"
                  :value="country.value">
                  {{ country.label }}
                </option>
              </select>
              <span
                v-if="errors && errors['country']"
                class="text-xs text-red-500"
                >{{ errors['country'][0] }}</span
              >
            </label>
            <label class="form__label">
              <span>{{ $t('commons.quoteForm.customerInfos.form.phone.label') }}</span>
              <div class="relative h-auto w-full">
                <input
                  v-model="form.phone"
                  :placeholder="$t('commons.quoteForm.customerInfos.form.phone.placeholder')"
                  class="form__input w-full bg-white"
                  name="phone"
                  required />
              </div>
              <span
                v-if="errors && errors['phone']"
                class="mt-2 text-xs text-red-500"
                >{{ errors['phone'][0] }}</span
              >
            </label>
          </div>
        </div>
      </div>
      <div class="mt-4 w-full p-5">
        <div class="mb-4 flex w-full items-center">
          <home class="h-4 w-4 text-primary" />
          <h3 class="ml-4 font-poppins text-xl font-medium">
            {{ `${$t('host_hotels.quoteForm.sections.second.title')} ${hostName}` }}
          </h3>
        </div>
        <div v-for="group in hostHotelGroups">
          <p
            v-if="group.hotels.length > 0"
            class="text-left">
            {{ group.name }}
          </p>
          <div
            v-if="group.hotels.length > 0"
            class="mb-2 mt-2 grid grid-cols-2 gap-x-2 gap-y-6 md:grid-cols-3">
            <button
              v-for="hotel in group.hotels"
              :key="hotel.id"
              class="relative flex flex-col justify-between text-left focus:outline-none"
              type="button"
              @click="selectHostHotel(hotel.id)">
              <div class="pt-full relative w-full overflow-hidden rounded-xl bg-white">
                <img
                  :src="hotel.thumbnail"
                  class="aspect-square w-full bg-black/10 object-cover" />
                <div
                  v-if="hotel.selected"
                  class="absolute left-0 top-0 flex h-full w-full items-center justify-center">
                  <svg
                    class="h-auto w-1/2"
                    fill="none"
                    height="36"
                    viewBox="0 0 36 36"
                    width="36"
                    xmlns="http://www.w3.org/2000/svg">
                    <rect
                      fill="#469752"
                      height="36"
                      rx="18"
                      width="36" />
                    <path
                      d="M14.6252 22.4826L10.0214 17.8789L9.9002 17.7576L9.77898 17.8789L8.20398 19.4539L8.08276 19.5751L8.20398 19.6963L14.504 25.9963L14.6252 26.1175L14.7464 25.9963L28.2464 12.4963L28.3676 12.3751L28.2464 12.2539L26.6714 10.6789L26.5502 10.5576L26.429 10.6789L14.6252 22.4826Z"
                      fill="white"
                      stroke="white"
                      stroke-width="0.342857" />
                  </svg>
                </div>
              </div>
              <span class="my-2 block text-center font-poppins font-normal">{{ hotel.title }}</span>
              <div
                v-if="hotel.price_range"
                class="attributes-list mb-6 flex w-full justify-between">
                <div
                  class="flex items-center whitespace-nowrap rounded-full border px-2 py-1 font-sans text-xs text-light">
                  <DollarPrice :price-range="hotel.price_range" />
                </div>
              </div>
            </button>
          </div>
          <span
            v-if="errors && errors['specific_fields.booking.host_hotel_id']"
            class="text-xs text-red-500"
            >{{ errors['specific_fields.booking.host_hotel_id'][0] }}</span
          >
        </div>
        <label class="form__label">
          <span>
            {{ $t('host_hotels.quoteForm.inputs.status.label') }}
          </span>
          <select
            v-model="form.specific_fields.booking.status"
            name="status"
            class="form__input bg-white">
            <option
              disabled
              :value="null">
              Sélectionner
            </option>
            <option
              v-for="status in statuses"
              :value="status.value">
              {{ status.label }}
            </option>
          </select>
          <span
            v-if="errors && errors['specific_fields.booking.status']"
            class="text-xs text-red-500"
            >{{ errors['specific_fields.booking.status'][0] }}</span
          >
        </label>
        <div class="grid grid-cols-2 gap-x-4">
          <label class="form__label">
            <span>{{ $t('host_hotels.quoteForm.inputs.dateStart.label') }}</span>
            <input
              id="start_date"
              v-model="form.specific_fields.booking.start_date"
              class="form__input"
              type="date" />
            <span
              v-if="errors && errors['specific_fields.booking.start_date']"
              class="text-xs text-red-500"
              >{{ errors['specific_fields.booking.start_date'][0] }}</span
            >
          </label>
          <div class="mt-6 pt-8">
            <label class="flex items-start justify-start">
              <div
                class="focus-within:border-secondary-500 mr-2 flex h-6 w-6 shrink-0 items-center justify-center rounded border-2 border-secondary bg-white">
                <input
                  v-model="form.specific_fields.booking.start_shuttle"
                  class="absolute opacity-0"
                  type="checkbox" />
                <svg
                  class="pointer-events-none hidden h-4 w-4 fill-current text-secondary"
                  viewBox="0 0 20 20">
                  <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
                </svg>
              </div>
              <div class="select-none">
                <span class="text-xs text-light">
                  {{ $t('host_hotels.quoteForm.inputs.shuttleStart.label') }}
                </span>
              </div>
            </label>
            <span
              v-if="errors && errors['specific_fields.booking.start_shuttle']"
              class="text-xs text-red-500"
              >{{ errors['specific_fields.booking.start_shuttle'][0] }}</span
            >
          </div>

          <label
            v-if="form.specific_fields.booking.start_shuttle"
            class="form__label">
            <span>{{ $t('host_hotels.quoteForm.inputs.startFlight.label') }}</span>
            <input
              v-model="form.specific_fields.booking.start_flight"
              :placeholder="$t('host_hotels.quoteForm.inputs.startFlight.placeholder')"
              class="form__input"
              type="text" />
            <span
              v-if="errors && errors['specific_fields.booking.start_flight']"
              class="text-xs text-red-500"
              >{{ errors['specific_fields.booking.start_flight'][0] }}</span
            >
          </label>

          <label
            v-if="form.specific_fields.booking.start_shuttle"
            class="form__label">
            <span>{{ $t('host_hotels.quoteForm.inputs.startLandingTime.label') }}</span>
            <input
              v-model="form.specific_fields.booking.start_landing_time"
              :placeholder="$t('host_hotels.quoteForm.inputs.startLandingTime.placeholder')"
              class="form__input"
              type="text" />
            <span
              v-if="errors && errors['specific_fields.booking.start_landing_time']"
              class="text-xs text-red-500"
              >{{ errors['specific_fields.booking.start_landing_time'][0] }}</span
            >
          </label>

          <label class="form__label">
            <span>{{ $t('host_hotels.quoteForm.inputs.dateEnd.label') }}</span>
            <input
              id="end_date"
              v-model="form.specific_fields.booking.end_date"
              class="form__input"
              type="date" />
            <span
              v-if="errors && errors['specific_fields.booking.end_date']"
              class="text-xs text-red-500"
              >{{ errors['specific_fields.booking.end_date'][0] }}</span
            >
          </label>
          <template v-if="showEndShuttle">
            <div class="mt-6 pt-8">
              <label class="flex items-start justify-start">
                <div
                  class="focus-within:border-secondary-500 mr-2 flex h-6 w-6 shrink-0 items-center justify-center rounded border-2 border-secondary bg-white">
                  <input
                    v-model="form.specific_fields.booking.end_shuttle"
                    class="absolute opacity-0"
                    type="checkbox" />
                  <svg
                    class="pointer-events-none hidden h-4 w-4 fill-current text-secondary"
                    viewBox="0 0 20 20">
                    <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
                  </svg>
                </div>
                <div class="select-none">
                  <span class="text-xs text-light">
                    {{ $t('host_hotels.quoteForm.inputs.shuttleEnd.label') }}
                  </span>
                </div>
              </label>
              <span
                v-if="errors && errors['specific_fields.booking.end_shuttle']"
                class="text-xs text-red-500"
                >{{ errors['specific_fields.booking.end_shuttle'][0] }}</span
              >
            </div>

            <label
              v-if="form.specific_fields.booking.end_shuttle"
              class="form__label">
              <span>{{ $t('host_hotels.quoteForm.inputs.endFlight.label') }}</span>
              <input
                v-model="form.specific_fields.booking.end_flight"
                :placeholder="$t('host_hotels.quoteForm.inputs.endFlight.placeholder')"
                class="form__input"
                type="text" />
              <span
                v-if="errors && errors['specific_fields.booking.end_flight']"
                class="text-xs text-red-500"
                >{{ errors['specific_fields.booking.end_flight'][0] }}</span
              >
            </label>

            <label
              v-if="form.specific_fields.booking.end_shuttle"
              class="form__label">
              <span>{{ $t('host_hotels.quoteForm.inputs.endLandingTime.label') }}</span>
              <input
                v-model="form.specific_fields.booking.end_landing_time"
                :placeholder="$t('host_hotels.quoteForm.inputs.endLandingTime.placeholder')"
                class="form__input"
                type="text" />
              <span
                v-if="errors && errors['specific_fields.booking.end_landing_time']"
                class="text-xs text-red-500"
                >{{ errors['specific_fields.booking.end_landing_time'][0] }}</span
              >
            </label>
          </template>
          <template v-else>
            <div class="mt-6 pt-8">&nbsp;</div>
          </template>

          <label class="form__label">
            <span>{{ $t('host_hotels.quoteForm.inputs.adults.label') }}</span>
            <select
              v-model="form.specific_fields.booking.adults"
              class="form__input bg-white">
              <option
                disabled
                :value="null">
                Sélectionner
              </option>
              <option
                v-for="adult in 15"
                :value="adult">
                {{ adult }}
              </option>
            </select>
            <span
              v-if="errors && errors['specific_fields.booking.adults']"
              class="text-xs text-red-500"
              >{{ errors['specific_fields.booking.adults'][0] }}</span
            >
          </label>

          <label class="form__label">
            <span>{{ $t('host_hotels.quoteForm.inputs.childs.label') }}</span>
            <select
              v-model="form.specific_fields.booking.child"
              class="form__input bg-white">
              <option
                disabled
                :value="null">
                Sélectionner
              </option>
              <option
                v-for="child in 16"
                :value="child - 1">
                {{ child - 1 }}
              </option>
            </select>
            <span
              v-if="errors && errors['specific_fields.booking.child']"
              class="text-xs text-red-500"
              >{{ errors['specific_fields.booking.child'][0] }}</span
            >
          </label>
        </div>

        <label
          v-if="form.specific_fields.booking.child > 0"
          class="form__label">
          <span>{{ $t('host_hotels.quoteForm.inputs.yearChilds.label') }}</span>
          <input
            v-model="form.specific_fields.booking.year_child"
            :placeholder="$t('host_hotels.quoteForm.inputs.yearChilds.placeholder')"
            class="form__input"
            type="text" />
          <span
            v-if="errors && errors['specific_fields.booking.year_child']"
            class="text-xs text-red-500"
            >{{ errors['specific_fields.booking.year_child'][0] }}</span
          >
        </label>

        <label class="form__label">
          <span>{{ $t('host_hotels.quoteForm.inputs.rooms.label') }}</span>
          <select
            v-model="form.specific_fields.booking.rooms"
            class="form__input">
            <option
              disabled
              :value="null">
              Sélectionner
            </option>
            <option
              v-for="room in 10"
              :value="room">
              {{ room }}
            </option>
          </select>
          <span
            v-if="errors && errors['specific_fields.booking.rooms']"
            class="text-xs text-red-500"
            >{{ errors['specific_fields.booking.rooms'][0] }}</span
          >
        </label>

        <label class="form__label">
          <span>{{ $t('host_hotels.quoteForm.inputs.message.label') }}</span>
          <textarea
            v-model="form.message"
            :placeholder="$t('host_hotels.quoteForm.inputs.message.placeholder')"
            class="mt-2 min-h-32 rounded-lg border border-light/25 bg-lightgray p-4 text-sm text-light md:bg-white">
          </textarea>
          <span
            v-if="errors && errors['message']"
            class="text-xs text-red-500"
            >{{ errors['message'][0] }}</span
          >
          <span class="mt-4 font-sans text-light">{{ $t('commons.quoteForm.mentions') }}</span>
        </label>
      </div>
      <div class="px-5 pb-5">
        <button
          class="btn"
          type="submit">
          {{ $t('buttons.send') }}
        </button>
      </div>
    </form>
  </div>
</template>
